/*
Endless-loop arithmetic shared by the carousels, without the DOM. Positions count
the items of a track including the edge clones (edgeClones.js): `clonesPerSide`
copies of the last items, then the `count` real items, then `clonesPerSide` copies
of the first ones. How a carousel turns its scroll offset into a position stays
with the carousel — the hero divides by the track width, the rubric ring picks the
block nearest to the centre.
*/

/**
 * The real item a clone copies.
 * @param {number} position Index in the track, clones included.
 * @param {number} clonesPerSide Clones on each edge.
 * @param {number} count Real items.
 * @returns {number|null} Position of the real twin, or null when `position` is real.
 */
export function realTwin(position, clonesPerSide, count) {
    if (position < clonesPerSide) {
        return position + count;
    }
    if (position >= clonesPerSide + count) {
        return position - count;
    }
    return null;
}

/**
 * Which real item (0-based) a position shows — a clone counts as its twin.
 * @param {number} position Index in the track, clones included.
 * @param {number} clonesPerSide Clones on each edge.
 * @param {number} count Real items.
 * @returns {number} 0 … count - 1.
 */
export function itemAt(position, clonesPerSide, count) {
    return (((position - clonesPerSide) % count) + count) % count;
}
